const PieSpinner = require('component/mainpage/classes/PieSpinner.js');
const pieSpinnerWrapper = $('#pie-spinner-wrapper-static');

if (pieSpinnerWrapper.length) {
	const pieSpinner = new PieSpinner({
		pieRotateNextSpeed: 5000,
		pieSpinSpeed: 300,
		pieInnerTextFadeSpeed: 500,
		pieDetailTextFadeSpeed: 500,
		pieArrowFadeSpeed: 200
	});

	pieSpinner.reset();
}



// WEBPACK FOOTER //
// ./temp/components/pie-spinner/index.js